import { SubscriptionType } from "../types/company";
import { IUser, UserResponse } from "../types/user";

class User {
  name: string;
  email: string;
  language: string;
  company?: {
    name: string;
    subscriptions: SubscriptionType[]; //TO BE deprecated
    subscription_access_level: SubscriptionType[];
  };

  constructor(parameters: UserResponse & IUser) {
    this.name = parameters.name;
    this.email = parameters.email;
    this.language = parameters.language;
    this.company = {
      name: parameters.company?.name,
      subscriptions: parameters.company?.subscriptions, //TO BE deprecated
      subscription_access_level: parameters.company?.subscription_access_level,
    };
  }

  getCompanyName = () => {
    return this.company?.name;
  };
}

export default User;
